// Mobile carousel for the footer service highlights: one highlight per view,
// dot indicators, optional auto-advance. On wider screens the grid is untouched.
const mobile = window.matchMedia('(max-width: 639px)');
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

class FooterFeaturesCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-features-track]');
    this.dots = [...this.querySelectorAll('[data-features-dot]')];
    if (!this.track) return;
    this.delay = Number(this.dataset.delay || 4) * 1000;
    this.autoplay = this.dataset.autoplay === 'true' && !reducedMotion.matches;
    this.paused = false;

    this.track.addEventListener('scroll', () => this.updateDots(), { passive: true });
    this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.goTo(i)));
    this.addEventListener('touchstart', () => { this.paused = true; }, { passive: true });
    this.addEventListener('touchend', () => { setTimeout(() => { this.paused = false; }, 5000); }, { passive: true });
    document.addEventListener('visibilitychange', this.onVisibility = () => { this.paused = document.hidden; });
    if (this.autoplay) this.timer = setInterval(() => this.advance(), this.delay);
    this.updateDots();
  }

  disconnectedCallback() {
    clearInterval(this.timer);
    document.removeEventListener('visibilitychange', this.onVisibility);
  }

  get count() {
    return this.track.children.length;
  }

  get index() {
    return Math.round(Math.abs(this.track.scrollLeft) / (this.track.clientWidth || 1));
  }

  goTo(i) {
    const sign = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
    this.track.scrollTo({ left: i * this.track.clientWidth * sign, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
  }

  advance() {
    if (!mobile.matches || this.paused) return;
    this.goTo((this.index + 1) % this.count);
  }

  updateDots() {
    const active = this.index;
    this.dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === active);
      dot.setAttribute('aria-current', i === active ? 'true' : 'false');
    });
  }
}

if (!customElements.get('footer-features-carousel')) {
  customElements.define('footer-features-carousel', FooterFeaturesCarousel);
}
